import { render, staticRenderFns } from "./HealthReports.vue?vue&type=template&id=45001b6e"
import script from "./HealthReports.vue?vue&type=script&lang=js"
export * from "./HealthReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45001b6e')) {
      api.createRecord('45001b6e', component.options)
    } else {
      api.reload('45001b6e', component.options)
    }
    module.hot.accept("./HealthReports.vue?vue&type=template&id=45001b6e", function () {
      api.rerender('45001b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/attendance/HealthReports.vue"
export default component.exports